<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.004 20.002"><path d="M10 20a10 10 0 1 1 10-10 10.011 10.011 0 0 1-10 10zm-1.272-4.832v2.3h2.434v-2.297H8.728zm1.333-9.69a1.689 1.689 0 0 1 1.716 1.907c0 .9-.308 1.445-1.318 2.327a3.962 3.962 0 0 0-1.731 3.411v.7h2.434v-.508c0-.989.291-1.521 1.348-2.468a4.215 4.215 0 0 0 1.7-3.538 3.79 3.79 0 0 0-4.145-3.938A4.287 4.287 0 0 0 6.97 4.485a3.86 3.86 0 0 0-1.077 2.827v.107h2.415a1.721 1.721 0 0 1 1.753-1.941z" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-question',
});
</script>
